import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import axios from 'axios';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Lock, User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Check if already logged in
    const auth = localStorage.getItem('admin_auth');
    if (auth) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const authString = btoa(`${credentials.username}:${credentials.password}`);
      const response = await axios.get(`${BACKEND_URL}/api/admin/verify`, {
        headers: { Authorization: `Basic ${authString}` }
      });

      if (response.data.authenticated) {
        localStorage.setItem('admin_auth', authString);
        toast.success('Connexion réussie!');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      toast.error('Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#060606] flex items-center justify-center px-4" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-8">
          <h1 className="font-display text-3xl text-[#F5F0E8] mb-2">ADMIN DASHBOARD</h1>
          <p className="text-sm text-[#B9B2A8]">Invasion Latina</p>
        </div>

        <form onSubmit={handleLogin} className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-6">
          <div>
            <label className="block text-xs uppercase tracking-wider text-[#B9B2A8] mb-2">
              Nom d'utilisateur
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#B9B2A8]" />
              <Input
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                className="pl-10 bg-white/5 border-white/10 text-[#F5F0E8]"
                placeholder="admin"
                required
                data-testid="admin-username-input"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs uppercase tracking-wider text-[#B9B2A8] mb-2">
              Mot de passe
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#B9B2A8]" />
              <Input
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                className="pl-10 bg-white/5 border-white/10 text-[#F5F0E8]"
                placeholder="••••••••"
                required
                data-testid="admin-password-input"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#C9A84C] text-[#060606] hover:bg-[#E2C56A] font-display uppercase tracking-wider"
            data-testid="admin-login-button"
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </Button>
        </form>

        <p className="text-center text-xs text-[#B9B2A8] mt-6">
          Accès réservé aux administrateurs
        </p>
      </motion.div>
    </div>
  );
};

export default AdminLoginPage;
